import Vue from 'vue';

/**
 * @deprecated Use SdsTooltip instead
 */
var script = Vue.extend({
    functional: true,
    props: {
        text: {
            type: String,
            required: true,
        },
        tag: {
            type: String,
            default: 'span',
        },
        position: {
            type: String,
            default: 'top',
        },
    },
});

export default script;
